// skipcq: JS-W1028
import { useMemo } from 'react';

import useBreweryBeers from './useBreweryBeers';
import { selectRecentlyAddedBeers, selectTopRatedBeers } from '../utils/brewhouseBeerStats';

/**
 * Brewhouse dashboard beer catalog — brewery scope query with derived lists.
 *
 * @param {string | string[] | null | undefined} breweryIdOrIds
 */
function useBrewhouseBeerCatalog(breweryIdOrIds) {
  const { beers, loading, error, refresh } = useBreweryBeers(breweryIdOrIds);

  const recentlyAdded = useMemo(() => selectRecentlyAddedBeers(beers), [beers]);
  const topRated = useMemo(() => selectTopRatedBeers(beers), [beers]);

  return {
    beers,
    recentlyAdded,
    topRated,
    loading,
    error,
    refresh,
  };
}

export default useBrewhouseBeerCatalog;
